import { push, ref } from "firebase/database";
import { useState } from "react";
import { db } from "../Firebase";
import CATEGORIES from "./categoryConfig";

const DynamicField = ({ field, value, onChange }) => {
  const cls = "form-control";
  if (field.type === "textarea")
    return (
      <textarea
        className={cls}
        rows={3}
        placeholder={field.label}
        value={value}
        onChange={(e) => onChange(field.name, e.target.value)}
        required={field.required}
      />
    );
  return (
    <input
      className={cls}
      type={field.type}
      placeholder={field.label}
      value={value}
      onChange={(e) => onChange(field.name, e.target.value)}
      required={field.required}
    />
  );
};

const VishishtForm = () => {
  const [categoryId, setCategoryId] = useState("");
  const [formData, setFormData] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const category = CATEGORIES.find((c) => c.id === categoryId);

  const handleCategoryChange = (e) => {
    setCategoryId(e.target.value);
    setFormData({});
    setSuccess(false);
    setError("");
  };

  const handleField = (name, value) => setFormData((p) => ({ ...p, [name]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await push(ref(db, "vishisht_panjikaran"), {
        categoryId,
        categoryLabel: category.label,
        data: formData,
        status: "pending",
        createdAt: Date.now(),
      });
      setSuccess(true);
      setCategoryId("");
      setFormData({});
    } catch (err) {
      setError("सबमिट करने में त्रुटि हुई। कृपया पुनः प्रयास करें।");
    }
    setSubmitting(false);
  };

  return (
    <div className="container py-5" style={{ maxWidth: 700 }}>
      <div className="card shadow-sm">
        <div
          className="card-header text-white text-center py-3"
          style={{ background: "#213F6D" }}
        >
          <h4 className="mb-0">🏅 विशिष्ठ पंजीयन</h4>
          <small>Vishisht Panjikaran – Special Registration</small>
        </div>
        <div className="card-body p-4">
          {success && (
            <div className="alert alert-success">
              ✅ आपका पंजीयन सफलतापूर्वक सबमिट हो गया। Admin की स्वीकृति के बाद यह सार्वजनिक होगा।
            </div>
          )}
          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            {/* Category selector */}
            <div className="mb-4">
              <label className="form-label fw-bold">श्रेणी चुनें (Category) *</label>
              <select
                className="form-select"
                value={categoryId}
                onChange={handleCategoryChange}
                required
              >
                <option value="">-- श्रेणी चुनें --</option>
                {CATEGORIES.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Dynamic fields */}
            {category && (
              <>
                <hr />
                <h6 className="text-muted mb-3">{category.label} – विवरण भरें</h6>
                {category.fields.map((field) => (
                  <div className="mb-3" key={field.name}>
                    <label className="form-label">
                      {field.label}
                      {field.required && <span className="text-danger"> *</span>}
                    </label>
                    <DynamicField
                      field={field}
                      value={formData[field.name] || ""}
                      onChange={handleField}
                    />
                  </div>
                ))}
                <button
                  type="submit"
                  className="btn w-100 text-white mt-2"
                  style={{ background: "#213F6D" }}
                  disabled={submitting}
                >
                  {submitting ? "सबमिट हो रहा है..." : "📤 पंजीयन सबमिट करें"}
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default VishishtForm;
